import { ReactNode } from 'react'
import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'
import IdeyaTypography from '../../../../common/antd/ideya-typography.tsx'

interface DashboardChartBoxProps {
  title: string
  children: ReactNode
}

export const DashboardChartBox: React.FC<DashboardChartBoxProps> = ({
  title,
  children,
}) => {
  const themeStyle = useAppSelector(selectThemeStyle)

  return (
    <div style={{ width: '100%' }}>
      <div style={{ marginBottom: themeStyle.marginXS }}>
        <IdeyaTypography.Text>{title}</IdeyaTypography.Text>
      </div>
      <div
        style={{
          width: '100%',
          padding: `${themeStyle.paddingBase} ${themeStyle.paddingLG}`,
          justifyContent: 'center',
          alignItems: 'center',
          gap: themeStyle.marginSM,
          alignSelf: 'stretch',
          borderRadius: '8px',
          border: `1px solid ${themeStyle.sumCardOutline}`,
          background: themeStyle.sumCardBg,
          backdropFilter: 'blur(4px)',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            gap: '4px',
            flex: '1 0 0',
            boxShadow: '2px',
            height: '100%',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
